<div class="bg-white p-3 rounded-10 custom-shadow" *ngIf="type == 'message'">
  <div class="row">
    <div class="col-auto chat-post-logo-icon">
      <ng-container *ngIf="_user.authUser | async as user; else noauth">
        <a [routerLink]="['/', user | UserSlug, 'profile', 'statistics']">
          <img
            [src]="(_user.authUser | async)?.user_avatar | baseUrl"
            class="shadow-sm"
          />
        </a>
      </ng-container>
      <ng-template #noauth>
        <img [src]="null | baseUrl" class="shadow-sm" />
      </ng-template>
    </div>
    <div class="col">
      <!-- (keydown.enter)="send.emit({ msg: msgbox.trim() }); msgbox = ''" -->
      <textarea
        name="textPost"
        #textbox
        [(ngModel)]="msgbox"
        rows="2"
        class="form-control me-2 me-md-4"
        placeholder="Type message here..."
      ></textarea>
      <div class="small text-blue-light text-f10 mt-1">
        Characters left: {{ 500 - msgbox.trim().length }}
      </div>
    </div>
    <div class="col-12 col-md-auto text-end">
      <button
        type="button"
        (click)="send.emit({ msg: msgbox.trim() }); msgbox = ''"
        class="btn btn-theme"
      >
        Post
      </button>
    </div>
  </div>
</div>

<div class="row mt-3" *ngIf="type == 'reply'">
  <div class="col-md-7">
    <textarea
      name="textPost"
      rows="1"
      class="form-control me-2 me-md-4 mb-2 mb-md-0"
      placeholder="Reply to {{ username | titlecase }}..."
      [(ngModel)]="msgbox"
    ></textarea>
  </div>
  <div class="col-12 col-md-auto text-end">
    <button
      type="button"
      class="btn btn-theme"
      (click)="reply.emit({ msg: msgbox.trim() }); msgbox = ''"
    >
      Post
    </button>
  </div>
</div>
